import type { ComponentPropsWithRef } from 'react';

import { cx } from '@/shared/lib/cx';

import styles from './swatch.module.scss';

const HEX = /^#[\da-f]{3,8}$/i;

export type SwatchProps = Omit<ComponentPropsWithRef<'button'>, 'color'> & {
  color: string;
  name: string;
  selected?: boolean;
  unavailable?: boolean;
  /** sm — 28px dot; md — 32px dot; lg — 28px dot in a 44px hit area. */
  size?: 'sm' | 'md' | 'lg';
};

/** Colour option. Unavailable colours stay focusable so the tip can explain why. */
export function Swatch({
  color,
  name,
  selected = false,
  unavailable = false,
  size = 'md',
  className,
  type = 'button',
  ...props
}: SwatchProps) {
  const style = { '--swatch-color': HEX.test(color) ? color : 'transparent' };
  return (
    <button
      {...props}
      type={type}
      className={cx(styles.root, className)}
      data-size={size}
      data-selected={selected || undefined}
      data-unavailable={unavailable || undefined}
      aria-pressed={selected}
      aria-disabled={unavailable || undefined}
      aria-label={unavailable ? `${name} — нет в наличии` : name}
    >
      <span className={styles.dot} style={style} />
    </button>
  );
}
